export default {
      id: "ic_filter_percent-usage",
      viewBox: "0 0 16 18",
      url: "/" + "images/icons.3.109.2.svg#ic_filter_percent-usage",
      toString: function () {
        return this.url;
      }
    }